export { default } from './AlumniDiscount';
export type { Props } from './AlumniDiscount';
